module.exports = __webpack_public_path__ + "static/media/5.ae565ebe.jpg";